import {
  AnimationConfigWithData,
  AnimationConfigWithPath,
  LottiePlayer as LottiePlayerWeb,
} from "lottie-web";
import { useEffect, useRef, useState } from "react";

export type Props = {
  className?: string;
} & (
  | Omit<AnimationConfigWithPath, "container">
  | Omit<AnimationConfigWithData, "container">
);

const LottiePlayer = ({ className, ...props }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [lottie, setLottie] = useState<LottiePlayerWeb | null>(null);

  useEffect(() => {
    import("lottie-web").then((l) => setLottie(l.default));
  }, []);

  useEffect(() => {
    if (lottie && ref.current) {
      const animation = lottie.loadAnimation({
        container: ref.current,
        ...props,
      });

      animation.addEventListener("complete", () => {
        animation.destroy();
      });
      return () => animation.destroy();
    }
    return undefined;
  }, [lottie, props]);

  return <div className={className} ref={ref} />;
};

export default LottiePlayer;
